export default __webpack_public_path__ + "static/ctaModule_cloud_bottom_desktop-619aebfbfee96252bae249c10008df91.png";